/**
 * Add a data attribute to rows to indicate how many child elements they contain. This is used for styling purposes, where CSS selectors alone are not possible.
 */
export const addChildrenCountDataAttributeToRows = () => {
  const rows = document.querySelectorAll('.en__component--row');

  rows.forEach((row) => {
    const childrenCount = row.children.length;
    row.setAttribute('data-children-count', childrenCount.toString());
  });
};
